$(document).ready(function() {

  $(document).on('click', '.specialist-booking-tool .advisor-scroll-js', function() {
    const target = $($(this).attr('target'));

    // Highlight the clicked element
    $('.advisor-scroll-js').removeClass('border-highlighted')
    $('.booking-calendar').removeClass('border-highlighted');
    $(this).addClass('border-highlighted');
    target.addClass('border-highlighted');

    // Scroll to the target element
    const bodyContainer = $('.body-container');
    bodyContainer.animate({
      scrollTop: bodyContainer.scrollTop() + target.position().top - 100
    }, {
      duration: 500,
      easing: 'swing'
    });
  });

});
